const state = {
    paymentRequests: [],
    currentStaff: {
        full_name: '',
    },
    requestedStaffList: [],
    otherStaffList: [],
}

const getters = {
    paymentRequests: state => {
        return state.paymentRequests
    },
    currentStaff: state => {
        return state.currentStaff
    },
    requestedStaffList: state => {
        return state.requestedStaffList
    },
    otherStaffList: state => {
        return state.otherStaffList
    }
}

const mutations = {
    updatePaymentRequests(state, paymentRequests) {
        state.paymentRequests = paymentRequests
    },
    updateCurrentStaff(state, staff) {
        state.currentStaff = staff
    },
    updateRequestedStaffList(state, staffList) {
        state.requestedStaffList = staffList
    },
    updateOtherStaffList(state, staffList) {
        state.otherStaffList = staffList
    }
}

const actions = {
    async getPaymentRequests({commit}, {staffId, startDate, endDate}) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = (await axios.get(`/admin/credit-tracking/api/staff/${staffId}/project-request`, {
                    params: {
                        start_date: startDate,
                        end_date: endDate
                    }
                }))

                const data = response.data,
                    requestList = data.data.requests

                await commit('updatePaymentRequests', requestList);
                await commit('updateCurrentStaff', data.data.staff.user);
                await resolve()
            } catch (error) {
                reject()
                console.log(error);
            }
        })
    },
    async getRequestedStaffList({commit}, {staffId, startDate, endDate}) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = (await axios.get(`/admin/credit-tracking/api/staff/${staffId}/requested-staff-list`, {
                    params: {
                        start_date: startDate,
                        end_date: endDate
                    }
                }))

                const data = response.data,
                    requestList = data.data.staffs

                await commit('updateRequestedStaffList', requestList);
                await resolve(response)
            } catch (error) {
                reject(error)
                console.log(error);
            }
        })
    },
    async getOtherStaffList({commit}, {staffId, startDate, endDate}) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = (await axios.get(`/admin/credit-tracking/api/staff/${staffId}/other-staff-list`, {
                    params: {
                        start_date: startDate,
                        end_date: endDate
                    }
                }))

                const data = response.data,
                    staffList = data.data.staffs

                await commit('updateOtherStaffList', staffList);
                await resolve(response)
            } catch (error) {
                reject(error)
                console.log(error);
            }
        })
    },
    /*async getRequestedStaffList({commit}, {staffId, startDate, endDate}) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = (await axios.get(`/admin/credit-tracking/api/staff/${staffId}/requested-staff-list`, {
                    params: {
                        start_date: startDate,
                        end_date: endDate
                    }
                }))

                const data = response.data,
                    requestList = data.data.staffs

                await commit('updateRequestedStaffList', requestList);
                await resolve(response)
            } catch (error) {
                reject(error)
                console.log(error);
            }
        })
    },*/
    async updateRequestCredits({commit, dispatch}, {formData}) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = (await axios.post(`/admin/credit-tracking/api/update-credits`, formData))

                resolve(response.data)
            } catch (error) {
                reject()
                console.log(error);
            }
        })
    },
    async updateRequestStatus({commit, dispatch}, {requestId, status, paymentUrl = null}){
        return new Promise( async (resolve, reject) => {
            try {
                const response = (await axios.post(`/admin/credit-tracking/api/request/${requestId}/status`,
                    {status: status, 'payment-url':paymentUrl}))
                resolve(response.data)
            } catch (error) {
                reject(error)
                console.log('error', error);
            }
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
